import {CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts'
import {useEffect, useMemo, useState} from 'react'
import moment from 'moment'
import PageLayout from '../../components/layout/PageLayout'
import WizSelect from '../../components/select/WizSelect'
import {useQueryRegisterUser} from '../../hooks/api/analysis/useQueryRegisterUser'

interface IProps {
    className?: string
}
const RegisterUsersDashBoard: React.FC<IProps> = () => {
    const [limit, setLimit] = useState(100)
    const [hide, setHide] = useState({})
    const {data, refetch} = useQueryRegisterUser(limit)
    let rgbColors = [
        'rgb(251, 206, 177)',
        'rgb(219, 112, 147)',
        'rgb(255, 68, 51)',
        'rgb(244, 180, 0)',
        'rgb(248, 108, 108)',
        'rgb(50, 23, 77)',
        'rgb(50, 74, 178)',
        'rgb(72, 60, 50)',
        'rgb(0, 73, 88)',
        'rgb(0, 144, 0)',
    ]

    const charts = useMemo(() => {
        if (data === undefined) {
            return []
        }

        return data.map(el => {
            return {
                ...el,
                date: moment.utc(el.day, 'YYYYMMDD').local().format('YYYY/MM/DD'),
            }
        })
    }, [data, limit])

    useEffect(() => {
        refetch()
    }, [data, limit])

    return (
        <PageLayout title="Lot Register User">
            <div className={'flex space-x-[10px]'}>
                <WizSelect optionKey={'graph_limit'} value={limit} onChange={e => setLimit(e as number)} />
            </div>
            <ResponsiveContainer width="100%" height={800}>
                <ComposedChart data={charts} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <XAxis height={200} dataKey="date" angle={-30} textAnchor="end" />
                    <YAxis orientation="left" domain={['dataMin', 'dataMax']} />
                    <Tooltip />
                    <Legend
                        verticalAlign="top"
                        onClick={e => {
                            setHide({
                                ...hide,
                                [String(e.dataKey)]: !hide[String(e.dataKey)],
                            })
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Line
                        dot={<div></div>}
                        dataKey={'active_count'}
                        type="monotone"
                        stroke="#413ea0"
                        strokeWidth={1}
                        activeDot={{r: 3}}
                        hide={hide['active_count'] === true}
                    />
                    <Line
                        dot={<div></div>}
                        type="monotone"
                        dataKey={'accumulate_count'}
                        stroke="#ff7300"
                        strokeWidth={1}
                        activeDot={{r: 3}}
                        hide={hide['accumulate_count'] === true}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </PageLayout>
    )
}

export default RegisterUsersDashBoard
